import {
   initStores,
   initStoreById,
   initCategories,
}  from 'sites/api/MixApi';
import {
   fetchDetailsStart,
   fetchDetailsFailed,
   fetchDetailsCompleted,
   fetchRequestByFilter,
   fetchRequestByFilterCompleted,
   fetchRequestByFilterFailed,
   fetchCategoriesCompleted,
   fetchNextDetailsStart,
   fetchNextDetailsCompleted,
   fetchNextDetailsFailed,
   fetchStoreByIdStart,
   fetchStoreByIdCompleted,
   fetchStoreByIdFailed,
   // updateStoreOrderCount,
   fetchNewOrdersStart,
   fetchNewOrdersCompleted,
   fetchNewOrdersFailed,
   fetchOrdersByFilterStart,
   fetchOrdersByFilterCompleted,
   fetchOrders,
   updateStoreById,
   fetchOrdersStart,
   fetchActiveOrderRequestStart,
   fetchActiveOrderRequestCompleted,
   updateStoreListAction,
} from "./actions";
import Router from 'sites/routes/router';
import { getOrderRequestById, getOrderRequests } from 'sites/api/AuthApi';
import { push } from 'connected-react-router';
import { changeNewOrdersCountAction, setIsGlobalLoadingAction } from '../common/actions';
import { updateContentPageTitle } from 'sites/utils/utils.js';

export const initStoreDataOperation = (params) => {
   return async (dispatch) => {
      dispatch(fetchDetailsStart());
      try {
         const { data }  = await initStores(params);
         // await initCategories();
         dispatch(fetchDetailsCompleted(data))
      } catch (error) {
         dispatch(fetchDetailsFailed())
      } finally {
         dispatch(setIsGlobalLoadingAction(false))
      }
   };
};

export const initCategoriesOperation = () => {
   return async (dispatch) => {
      try {
         const { data }  = await initCategories();
         const newData = data.map(el => {
            return {
               value: el.id,
               name: el.name,
            }
         })
         dispatch(fetchCategoriesCompleted(newData))
      } catch (error) {
      }
   };
};

export function fetchNextStoreDataOperation(params) {
   return async (dispatch) => {
      dispatch(fetchNextDetailsStart());
      try {
         const { data }  = await initStores(params);
         dispatch(fetchNextDetailsCompleted(data))
      } catch (error) {
         dispatch(fetchNextDetailsFailed())
      }
   };
}

export function fetchStoreByFilterOperation(params = []) {
   return async dispatch => {
      dispatch(fetchRequestByFilter());
      try {
         const { data }  = await initStores(params, true);
         dispatch(fetchRequestByFilterCompleted(data))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(fetchRequestByFilterFailed(error));
      } finally {
         dispatch(setIsGlobalLoadingAction(false))
      }
   }
}

export const initStoreByIdOperation = (id, callback, update = false) => {
   return async (dispatch) => {
      if(!update) {
         dispatch(fetchStoreByIdStart());
      }
      try {
         let { data }  = await initStoreById(id);
         let configuredData = { ...data }

         if(configuredData?.product_type === 'content_bundle_item') {

            let vault_images = []
            let vault_videos = []
            let photosets = []
            let videos = []
            let recorded_stream = []

            configuredData?.content_bundle?.forEach(item => {
               if(item?.contentable_type === 'video') {
                  videos = [
                     ...videos,
                     {
                        ...item.contentable,
                        type: 'videos',
                        order: item?.order,
                        icon: 'videos',
                        image_full_src: item?.contentable?.poster_src,
                        contentable_type: item?.contentable_type,
                     },
                  ]
               }
               else if(item?.contentable_type === 'vault_image') {
                  vault_images =  [
                     ...vault_images,
                     {
                        ...item.contentable,
                        type: 'photosets',
                        order: item?.order,
                        image_full_src: item?.contentable?.vault_bundle_item_poster_full_src,
                        icon: 'image',
                        photos_count: 1,
                        title: item?.title || 'Photo',
                        contentable_type: item?.contentable_type,
                     },
                  ]
               } else if(item?.contentable_type === 'vault_video') {
                  vault_videos =  [
                     ...vault_videos,
                     {
                        ...item.contentable,
                        type: 'videos',
                        order: item?.order,
                        image_full_src: item?.contentable?.vault_bundle_item_poster_full_src,
                        icon: 'videos',
                        title: item?.title || 'Video',
                        duration: item?.contentable?.video_duration,
                        contentable_type: item?.contentable_type,
                     },
                  ]
               } else if(item?.contentable_type === 'photoset') {
                  photosets =  [
                     ...photosets,
                     {
                        ...item.contentable,
                        image_full_src: item?.contentable?.cover_image?.cf_path,
                        photos_count: item?.contentable?.photos_count,
                        type: 'photosets',
                        icon: 'photosets',
                        order: item?.order,
                        contentable_type: item?.contentable_type,
                     },
                  ]
               } else if(item?.contentable_type === 'recorded_stream') {
                  recorded_stream =  [
                     ...recorded_stream,
                     {
                        ...item.contentable,
                        image_full_src: item?.contentable?.poster_src,
                        type: 'recorded_stream',
                        icon: 'livestream',
                        order: item?.order,
                        contentable_type: item?.contentable_type,
                     },
                  ]
               }
            })

            vault_images = vault_images?.sort((a, b) => a.order - b.order)
            vault_videos = vault_videos?.sort((a, b) => a.order - b.order)
            photosets = photosets?.sort((a, b) => a.order - b.order)
            videos = videos?.sort((a, b) => a.order - b.order)
            recorded_stream = recorded_stream?.sort((a, b) => a.order - b.order)

            let content = {
               photosets: [...photosets, ...vault_images],
               videos: [...videos,  ...vault_videos],
               recorded_stream: [...recorded_stream],
            }

            configuredData = {
               ...configuredData,
               content,
               price: configuredData?.bundle_price,
            }
         }

         if(!update) {
            dispatch(fetchStoreByIdCompleted(configuredData))
         } else {
            dispatch(updateStoreById({ storeDetails: configuredData, inited: false }))
            dispatch(updateStoreListAction({ ...configuredData }, 'update'))
         }
         Router.route('STORE_DETAILS').setTitle(configuredData.name)
         callback && callback(configuredData)
      } catch (error) {
         const status = error?.response?.status;
         if(403 !== status && 401 !== status){
            dispatch(updateStoreListAction({ id }, 'delete'))
            dispatch(push({
               pathname: Router.route("STORE").getCompiledPath(),
            }))
            return
         }
         dispatch(fetchStoreByIdFailed())
      }
   };
};

//orders
export const fetchOrdersData = (query = []) => {
   return async (dispatch) => {
      dispatch(fetchOrdersStart())
      try {
         if(query.length > 2) {
            dispatch(fetchOrdersByFilter(query))
            return
         }
         const { data } = await getOrderRequests(query)
         dispatch(fetchOrders(data))
      } catch (error) {
         console.log(error);
      }
      finally {
         dispatch(setIsGlobalLoadingAction(false))
      }
   }
}

export const fetchNewOrders = (query = []) => {
   return async (dispatch) => {
      dispatch(fetchNewOrdersStart())
      try {
         const { data } = await getOrderRequests(query)
         dispatch(fetchNewOrdersCompleted(data))
      } catch (error) {
         dispatch(fetchNewOrdersFailed())
      }
   }
}

export const fetchOrdersByFilter = (query = []) => {
   return async (dispatch) => {
      dispatch(fetchOrdersByFilterStart())
      try {
         const { data } = await getOrderRequests(query)
         dispatch(fetchOrdersByFilterCompleted(data))
      } catch (error) {
         console.log(error);
      }
   }
}


export const fetchOrderRequestById = (id, callBack, updateGlobalLoading) => {
   return async (dispatch) => {
      dispatch(fetchActiveOrderRequestStart())
      try {
         const { data } = await getOrderRequestById(id);
         if(data?.item_details?.name){
            updateContentPageTitle(data.item_details.name);
         }
         dispatch(changeNewOrdersCountAction(data?.new_order_requests_count))
         dispatch(fetchActiveOrderRequestCompleted(data))
         if(!!callBack) {
            callBack(data)
         }
      } catch (error) {

      } finally {
         if(updateGlobalLoading) {
            dispatch(setIsGlobalLoadingAction(false))
         }
      }
   };
};
